import * as Business    from '../business';
import * as User        from '../user';
import { connect }      from 'react-redux';
import React            from 'react';
import TabPage          from '../components/tab_page';
import TabPageLink      from '../components/tab_page_link';

import AdminIcon        from '../assets/icons/admin.svg';
import HelpIcon         from '../assets/icons/help.svg';
import LegalIcon        from '../assets/icons/legal.svg';
import NotificationIcon from '../assets/icons/notification.svg';

export default connect(
  (state, { businessID, path }) => ({
    business:        Business.getBusiness(state, businessID),
    userName:        User.getUserName(state),
    roleDisplayName: User.getRoleDisplayName(state, businessID),
    path
  })
)(AccountTab);


export function AccountTab({
  tabActive,
  business,
  userName,
  roleDisplayName
}) {
  return (
    <TabPage name="settings" title="Account">
      <div className="page-content">
        {business && (
          <TabLinks {...{
            tabActive,
            userName,
            roleDisplayName,
            business
          }}/>
        )}
      </div>
    </TabPage>
  );
}


function TabLinks({
  tabActive,
  userName,
  roleDisplayName,
  business
}) {
  return (
    <div className="list media-list">
      <ul>
        <TabPageLink
          active={[ 'Profile', 'ChangePassword' ].includes(tabActive)}
          href={`/${business.id}/account/profile`}
          title={userName}
          subtitle={roleDisplayName}
          icon={<AdminIcon/>}/>
        <TabPageLink
          active={tabActive === 'Notifications'}
          href={`/${business.id}/account/notifications`}
          title="Notifications"
          subtitle="Manage notification preferences"
          icon={<NotificationIcon/>}/>
        <TabPageLink
          active={[ 'Legal', 'Terms', 'Privacy' ].includes(tabActive)}
          href={`/${business.id}/account/legal`}
          title="Legal"
          subtitle="ToS & Privacy Policy"
          icon={<LegalIcon/>}/>
        <TabPageLink
          active={tabActive === 'Help'}
          href={`/${business.id}/account/help`}
          title="Help"
          subtitle="Questions? We have answers"
          icon={<HelpIcon/>}/>
      </ul>
    </div>
  );
}
